<template>
  <CardComponent variant="tertiary">
    <template v-slot:header>
      {{ $t('billing.prefs.header') }}
    </template>
    <div class="card-title font-size-40 font-w-300 p-l-20 counter text-title">{{ formattedBalance }}</div>
    <ButtonComponent is-block @click="addFunds">Adicionar Crédito</ButtonComponent>
  </CardComponent>
</template>

<script>
import CardComponent from '@/components/CardComponent.vue';
import ButtonComponent from '@/components/ui/ButtonComponent.vue';

export default {
  name: 'BillingSettingsCard',
  components: {
    CardComponent,
    ButtonComponent,
  },
  data() {
    return {};
  },
  computed: {
    formattedBalance() {
      return parseFloat(this.$store.state.account.balance).toLocaleString('pt-BR', {
        style: 'currency',
        currency: this.$store.state.account.currency.length ? this.$store.state.account.currency : 'BRL',
      });
    },
  },
  methods: {
    addFunds() {
      this.$router.push({ name: 'MakeInvoice' });
    },
  },
};
</script>
